<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">{{
      subClient ? 'SubCliente' : 'Cliente'
    }}</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-6">
    <div class="flex justify-between mb-5 items-center">
      <div [formGroup]="form">
        <mat-form-field
          class="input-tg pr-2 w-2/8 no-message-new"
          appearance="outline"
        >
          <mat-label>Tipo Cliente</mat-label>
          <mat-select
            formControlName="filter"
            (selectionChange)="onSelectionChangeFilter($event)"
          >
            @for (type of listFiler; track type) {
              <mat-option [value]="type.value">{{
                type.description
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="w-w-1/8">
        @if (createBtn) {
          <button mat-flat-button class="btn-tg" (click)="newClient()">
            <mat-icon>add</mat-icon>
            {{ subClient ? 'SubCliente' : 'Cliente' }}
          </button>
        }
      </div>

      <div class="flex-1"></div>
      <button
        mat-flat-button
        class="btn-tg-white w-1/5"
        (click)="removeSelection()"
      >
        Remover
      </button>
      <button
        mat-flat-button
        class="btn-tg w-1/5 ml-2"
        [disabled]="!checkForm()"
        (click)="confirmSelection()"
      >
        Confirmar
      </button>
    </div>
    <div>
      <form-client-search
        [search]="inputSearch"
        [listSearch]="listSearch"
        (responseSearch)="search($event)"
      />
      @if (!loading) {
        <div>
          <table-list-select
            [dataSource]="itemsList"
            [columns]="columns"
            [multiSelect]="multiSelect"
            [selected]="selected"
            [listSelected]="listSelected"
            (selectItem)="selectItem($event)"
          />
        </div>
        <div>
          @if (itemsList.length > 0) {
            <pagination
              [currentPage]="page"
              [pageSize]="rows"
              [totalRecords]="numberRows"
              (pageChanged)="pageChanged($event)"
            />
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</mat-card>
